var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cooperate"},[_c('top-nav',{attrs:{"banner":_vm.cooperate.banner,"white":"","isParent":""}}),_vm._v(" "),_c('strengths'),_vm._v(" "),_c('cases'),_vm._v(" "),_c('footer-resolution'),_vm._v(" "),_c('my-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }